import React from 'react';
import {
  EmailIcon,
  EmailShareButton,
  ViberIcon,
  ViberShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';
import Dialog from 'pencil/Dialog';
import DialogActions from 'pencil/DialogActions';
import DialogContent from 'pencil/DialogContent';
import DialogContentText from 'pencil/DialogContentText';
import DialogTitle from 'pencil/DialogTitle';
import * as I18n from 'circe/I18n';
import Button from 'pencil/Button';
import { makeStyles } from 'pencil/styles';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const useStyles = makeStyles(
  (theme) => ({
    code: {
      padding: theme.spacing(1),
      border: `1px solid ${theme.colors.lightGrey}`,
      marginTop: theme.spacing(1),
      color: theme.colors.black,
      textAlign: 'center',
      display: 'block',
    },
  }),
  { name: 'CompanyDialog' },
);

const CompanyDialog = ({ open, handlePopupClose, accountToken }) => {
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={handlePopupClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{I18n.str('companyCode', 'Company Code')}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {I18n.str(
            'shareThisCode',
            'Share the code below with your teammates to join your company',
          )}
          <br />
          <span className={classes.code}>{accountToken}</span>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <EmailShareButton
          subject="Join us!"
          body={`You can join my company on this code:  ${accountToken}\nTo register:`}
          url={`${window.location.origin}/register`}
        >
          <EmailIcon logoFillColor="white" size={40} />
        </EmailShareButton>

        <ViberShareButton
          title={`You can join my company on this code:  ${accountToken}\nTo register: ${window.location.origin}/register`}
        >
          <ViberIcon logoFillColor="white" size={40} />
        </ViberShareButton>
        <WhatsappShareButton
          title={`You can join my company on this code:  ${accountToken}\nTo register: ${window.location.origin}/register`}
        >
          <WhatsappIcon logoFillColor="white" size={40} />
        </WhatsappShareButton>
        <CopyToClipboard
          text={`
         You can join my company on this code:  ${accountToken}\nTo register:
          ${window.location.origin}/register
        `}
        >
          <Button color="primary">Copy to clipboard</Button>
        </CopyToClipboard>
        <div style={{ flex: '1 0 0' }} />
        <Button onClick={handlePopupClose} color="secondary" autoFocus>
          {I18n.str('close', 'Close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompanyDialog;
